import {
  ComunicazioneDTO,
  Destinatario,
  EnumDestinatarioStatoComunicazione,
  EnumDestinatarioStatoProtocollazione,
} from '@framework/api-client';

export class CommunicationLogic {
  static sender(communication: ComunicazioneDTO | null | undefined) {
    return (
      communication?.utenteMittente ??
      communication?.procedimentoMittente ??
      communication?.altroUfficioVariabileMittente
    );
  }

  static allRecipients(communication: ComunicazioneDTO | null | undefined) {
    return [
      ...(communication?.destinatariRichiedenti ?? []),
      ...(communication?.destinatariProcedimenti ?? []),
      ...(communication?.destinatariAltriUfficiVariabile ?? []),
    ];
  }

  static isDraft(communication: ComunicazioneDTO | null | undefined) {
    return (
      communication != null &&
      !communication.flCaricataManualmente &&
      communication.dataInvio == null
    );
  }

  static hasRecipientErrors(recipient: Destinatario | null | undefined) {
    return (
      recipient?.statoComunicazione ==
        EnumDestinatarioStatoComunicazione.FALLIMENTO ||
      recipient?.statoProtocollazione ==
        EnumDestinatarioStatoProtocollazione.FALLIMENTO
    );
  }
}
